import { AnimatePresence } from 'framer-motion';
import { useClientContext } from '../../contexts/ClientProvider';
import { Client } from '../../types/users';
import ClientDetailsModal from '../CommonComps/Modals/ClientDetailsModal';

const ClientDetailsModalSection = () => {
  // integration of context hooks here
  const { client, setClient, showDetailsModal, setShowDetailsModal } =
    useClientContext();

  // rendering client details modal section component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showDetailsModal && (
          <ClientDetailsModal
            client={client as Client}
            handleModalClose={() => {
              setShowDetailsModal(false);
              setClient(null);
            }}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default ClientDetailsModalSection;
